import * as actionType from './actionType';

export const detailVrRequest = data => ({
  type: actionType.TIMESHEET.DETAIL_VR_REQUEST,
  payload: data
})
export const detailVrSuccess = data => ({
  type: actionType.TIMESHEET.DETAIL_VR_SUCCESS,
  payload: data
})
export const detailVrError = data => ({
  type: actionType.TIMESHEET.DETAIL_VR_ERROR,
  payload: data
})
export const detailVrReset = data => ({
  type: actionType.TIMESHEET.DETAIL_VR_RESET,
  payload: data
})

export const validateVrRequest = data => ({
  type: actionType.TIMESHEET.VALIDATE_VR_REQUEST,
  payload: data
})
export const validateVrSuccess = data => ({
  type: actionType.TIMESHEET.VALIDATE_VR_SUCCESS,
  payload: data
})
export const validateVrError = data => ({
  type: actionType.TIMESHEET.VALIDATE_VR_ERROR,
  payload: data
})
export const validateVrReset = data => ({
  type: actionType.TIMESHEET.VALIDATE_VR_RESET,
  payload: data
})

export const checkinVrRequest = data => ({
  type: actionType.TIMESHEET.CHECKIN_VR_REQUEST,
  payload: data
})
export const checkinVrSuccess = data => ({
  type: actionType.TIMESHEET.CHECKIN_VR_SUCCESS,
  payload: data
})
export const checkinVrError = data => ({
  type: actionType.TIMESHEET.CHECKIN_VR_ERROR,
  payload: data
})
export const checkinVrReset = data => ({
  type: actionType.TIMESHEET.CHECKIN_VR_RESET,
  payload: data
})

export const checkoutVrRequest = data => ({
  type: actionType.TIMESHEET.CHECKOUT_VR_REQUEST,
  payload: data
})
export const checkoutVrSuccess = data => ({
  type: actionType.TIMESHEET.CHECKOUT_VR_SUCCESS,
  payload: data
})
export const checkoutVrError = data => ({
  type: actionType.TIMESHEET.CHECKOUT_VR_ERROR,
  payload: data
})
export const checkoutVrReset = data => ({
  type: actionType.TIMESHEET.CHECKOUT_VR_RESET,
  payload: data
})